import React, { useState } from 'react';
import AdminAPIServiceClients from './AdminAPIServiceClients';

const AdminAPIServices = () => {
    const [selectedService, setSelectedService] = useState(null);

    // Hardcoded services for now, similar to backend
    const services = [
        {
            id: 'docu_stamp',
            name: 'Docu Stamp API',
            description: 'Queue-based document retrieval API with consumption tracking',
            icon: '🧩'
        },
        {
            id: 'esign',
            name: 'eSign API',
            description: 'Aadhar-based electronic signature API',
            icon: '✍️'
        },
        {
            id: 'digisign',
            name: 'Digital Signature',
            description: 'Secure digital signing API (Email/URL/DSC modes)',
            icon: '✍️'
        },
        {
            id: 'bulk_order_management',
            name: 'Bulk Order Management',
            description: 'High-performance bulk order creation and management API',
            icon: '📦'
        },
        {
            id: 'live_stamping',
            name: 'Live Stamping API',
            description: 'Real-time single document e-stamping with wallet integration',
            icon: '⚡'
        },
        {
            id: 'doqsolv',
            name: 'DoqSolv API',
            description: 'Dynamic agreement generation and template management',
            icon: '📄'
        },
        {
            id: 'workflows',
            name: 'Service Workflow Engine',
            description: 'Visual workflow builder and orchestration engine',
            icon: '🔄'
        }
    ];

    if (selectedService) {
        return (
            <AdminAPIServiceClients
                service={selectedService}
                onBack={() => setSelectedService(null)}
            />
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="mb-6">
                <h2 className="text-xl font-bold text-gray-900">API Services Management</h2>
                <p className="text-sm text-gray-600 mt-1">
                    Manage API services, client access, and pricing configuration
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {services.map((service) => (
                    <div
                        key={service.id}
                        className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow cursor-pointer bg-gray-50 hover:bg-white"
                        onClick={() => setSelectedService(service)}
                    >
                        <div className="flex items-center justify-between mb-4">
                            <div className="text-4xl">{service.icon}</div>
                            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
                                Available
                            </span>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                            {service.name}
                        </h3>
                        <p className="text-sm text-gray-600 mb-4">
                            {service.description}
                        </p>
                        <button
                            className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition-colors text-sm font-medium"
                        >
                            Manage Clients
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminAPIServices;
